module.exports = __webpack_public_path__ + "img/ssb_menu12.b501122e.png";